import React from 'react'
import CardUI from '../../../widgets/layout/CardUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LoanDocumentNavSF from '../../../components/superUser/loan/LoanDocumentNavSF.js'
import LoanDocumentSubNavSF from '../../../components/superUser/loan/LoanDocumentSubNavSF.js'

const LoanAgreementAnnexuresPageUI = ({ context, errorList, loan, annexures, onRefreshClick
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_ftl'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!annexures || !errorList} loan={loan} page='loanDoc'
    dimension='w1600'
  >
    {
      (!annexures || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      annexures &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Loan documents</b></span>
            </span>
          }
          right={<span />}
        />

        <LoanDocumentNavSF context={context} loan={loan} documentType='loanAgreement' />
        <LoanDocumentSubNavSF
          context={context}
          loan={loan}
          documentCode='agreement_cum_doh_2'
          basePath='loanAgreement'
          page='annexures'
          onRefreshClick={onRefreshClick}
        />

        <div className='g_flex_h g_flex_top g_flex_left'>
          <CardUI title='Annexures'>
            <div>
              <span dangerouslySetInnerHTML={{ __html: annexures }} />
            </div>
          </CardUI>
        </div>

      </div>
    }
  </SuperUserLoanPageUI>


export default LoanAgreementAnnexuresPageUI
